import { render, staticRenderFns } from "./OrderListTd7.vue?vue&type=template&id=6bca4073&scoped=true"
import script from "./OrderListTd7.vue?vue&type=script&lang=js"
export * from "./OrderListTd7.vue?vue&type=script&lang=js"
import style0 from "./OrderListTd7.vue?vue&type=style&index=0&id=6bca4073&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bca4073",
  null
  
)

export default component.exports